import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { setBanId, setBanError, selectUserById } from "../../../store/mine_craft/usersSlice";
import { fetchUser, blockUser, banIpUser } from "../../../actions/mine_craft/usersActions";
import { fetchBannedIps } from "../../../actions/mine_craft/bannedIpsActions";
import { objToFormData } from "../../../helpers/FormHelper";

import { AudioOutlined, CheckCircleOutlined, StopOutlined } from "@ant-design/icons";
import { Button as ButtonAnt, Form, Input, Divider, Tag, message } from "antd";
import DrawerRight from "../../../componets/DrawerRight";
import AlertBlock from "../../../componets/AlertBlock";
import FormBlock from "./_partials/_FormBlock";
import Meta from "./_partials/_Meta";
import RowInfo from "../../../componets/RowInfo";
import { formattedDate } from "../../../helpers/DateHelpers";
import { Button } from "../../../componets/Buttons";

const Block = () => {
  const dispatch = useAppDispatch();
  const id: any = useAppSelector(state => state.mineCraft.users.banId);
  const error   = useAppSelector(state => state.mineCraft.users.banError);
  const user    = useAppSelector(state => selectUserById(state, id));
  const [banIpForm] = Form.useForm();
  const [banIpLoading, setBanIpLoading] = useState(false);

  useEffect(() => {
    if (id) {
      dispatch(fetchUser(id));
    }
  }, [id, dispatch]);

  useEffect(() => {
    banIpForm.resetFields();
  }, [id, banIpForm]);

  function onCloseError() {
    dispatch(setBanError(null));
  }

  function onClose() {
    dispatch(setBanId(null));
  }

  function onClickUnBlock(type: 'ban' | 'mute') {
    handleSave({ type: type, period: 0, duration: 'days' }).catch(console.error);
  }

  function onFinish(data: any) {
    handleSave(data).catch(console.error);
  }

  async function handleSave(data: any) {
    const formData = objToFormData(data);
    dispatch(blockUser({ id, data: formData }));
  }

  async function onBanIp(values: any) {
    setBanIpLoading(true);
    const resultAction = await dispatch(banIpUser({ id, data: values }));
    setBanIpLoading(false);

    if (banIpUser.fulfilled.match(resultAction)) {
      message.success('User IPs have been banned');
      dispatch(fetchBannedIps({ active: 'true' }));
    }
  }

  const userIps = user?.reg_sign_in_ip ? [user.reg_sign_in_ip] : [];
  const uniqueIps = Array.from(new Set(userIps));

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-user'>
        <h6 className="v-content-label">Block User</h6>

        <div className='v-mb-20'>{<Meta user={user} />}</div>

        <div className='v-mb-20'>
          {
            user?.muted &&
              <RowInfo
                  left={
                    <>
                      Muted Until: <u>{formattedDate(user?.muted_until).dateTime}</u>
                    </>
                  }
                  right={<Button onClick={() => onClickUnBlock('mute')} title='Remove Mute' icon={AudioOutlined} />}
              />
          }
          {
            user?.banned &&
              <RowInfo
                left={
                  <>
                    Banned Until: <u>{formattedDate(user?.banned_until).dateTime}</u>
                  </>
                }
                right={<Button onClick={() => onClickUnBlock('ban')} title='Remove Ban' icon={CheckCircleOutlined} />}
              />
          }
        </div>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        <FormBlock params={{ period: 5, duration: 'minutes', type: 'mute' }} onFinish={onFinish} />
        <FormBlock params={{ period: 1, duration: 'days', type: 'ban' }} onFinish={onFinish} />

        <Divider />

        <h6 className="v-content-label">Ban IP</h6>
        {uniqueIps.length > 0 && (
          <div className='v-mb-10'>
            {uniqueIps.map(ip => <Tag key={ip}>{ip}</Tag>)}
          </div>
        )}

        <Form
          form={banIpForm}
          onFinish={onBanIp}
          layout="vertical"
          className='v-form'
          initialValues={{ reason: `Banned via user block #${user?.id}` }}
        >
          <Form.Item name='reason' label="Reason">
            <Input.TextArea placeholder='Ban reason' rows={2} />
          </Form.Item>

          <Form.Item>
            <ButtonAnt
              type="primary"
              htmlType="submit"
              loading={banIpLoading}
              icon={<StopOutlined />}
              style={{ width: '100%' }}
              className="v-btn v-btn-primary"
            >
              Ban All User IPs
            </ButtonAnt>
          </Form.Item>
        </Form>

        <Divider />

        <ButtonAnt
          className="v-btn v-btn-primary"
          onClick={onClose}
          style={{ width: '100%' }}
        >
          Close
        </ButtonAnt>
      </div>
    </DrawerRight>
  )
}

export default Block;
